// Hakediş/fatura durum kodları — backend `PaymentStatus` enum'uyla BİREBİR.
// Filo hakedişi, kurye hakedişi ve her iki taraftaki faturalar AYNI enum'u taşır; bu yüzden
// tek harita. Sayfaların kendi yerel haritasını tutması, enum 4 değerden 5 değere çıkınca
// kaymaya dönüşmüştü: "Onay Bekliyor"(1) ekranda "Onaylandı" görünüyordu.
// Backend statusText alanı Status.ToString() ile İngilizce düşebildiği için (ör. "Rejected")
// arayüzde kullanılmaz; Türkçe etiketin tek kaynağı burasıdır.
export const PAYMENT_STATUS = {
    0: { label: 'Fatura Bekleniyor', tone: 'waiting' },
    1: { label: 'Onay Bekliyor', tone: 'pending' },
    2: { label: 'Onaylandı', tone: 'approved' },
    3: { label: 'Ödendi', tone: 'paid' },
    4: { label: 'Reddedildi', tone: 'rejected' },
};

export const getPaymentStatus = (status) => PAYMENT_STATUS[status] || { label: 'Bilinmiyor', tone: 'unknown' };

// Filo hakedişi ekranlarındaki mevcut çağrı adı — aynı haritayı döner.
export const getFleetPaymentStatus = getPaymentStatus;

// "Fatura yükle" bağlantısı/düğmesi yalnızca fatura bekleyen (0) veya reddedilen (4) hakedişlerde gösterilir.
export const canUploadFleetInvoice = (status) => status === 0 || status === 4;

// Yönetici aksiyon eşikleri — backend guard'larıyla birebir:
// ApprovePaymentAsync yalnız PendingApproval(1), MarkAsPaidAsync yalnız Approved(2) kabul eder.
// Eşikler kayınca ekran "Onayla" yerine "Ödendi İşaretle" gösteriyor, buton da backend'den
// dönüyordu: hakediş hiç onaylanamıyordu.
export const canApprovePayment = (status) => status === 1;
export const canMarkPaymentPaid = (status) => status === 2;
